import React, { useMemo } from 'react';
import { View, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import QText from './QText';
import { useTheme } from 'react-native-paper';
import Constants from 'expo-constants';
import BackArrowIcon from './Icons/BackArrowIcon';
const DetailedHeader = ({
  title,
  subTitle,
  rightContent,
  isShowBack,
  onBackPress,
  titleStyle,
}) => {
  const theme = useTheme();
  const styles = useMemo(() => createStyles(theme), [theme]);
  return (
    <View style={styles.headerContainer}>
      <View
        style={{
          paddingLeft: isShowBack && rightContent && 30,
          alignItems: 'center',
        }}
      >
        <QText style={styles.subTitleText}>{subTitle}</QText>
      </View>
      <View style={[styles.headerInline]}>
        <View
          style={{
            flexDirection: 'row',
            width: !rightContent ? '100%' : '90%',
            alignItems: 'center',
          }}
        >
          {isShowBack && (
            <TouchableOpacity
              onPress={onBackPress}
              accessible={true}
              accessibilityLabel={`back_button`}
              style={{ zIndex: 1, marginRight: 5 }}
            >
              <BackArrowIcon color={theme.colors.secondaryText} />
            </TouchableOpacity>
          )}
          <QText
            style={[
              styles.titleText,
              titleStyle,
              {
                textAlign: !rightContent ? 'left' : 'auto',
                marginLeft: !rightContent ? 15 : 0,
              },
            ]}
          >
            {title}
          </QText>
        </View>
        {rightContent && (
          <TouchableOpacity onPress={rightContent.onClick}>
            <QText style={styles.buttonText}>
              {rightContent.icon && rightContent.icon}
              {rightContent.buttonText && rightContent.buttonText}
            </QText>
          </TouchableOpacity>
        )}
      </View>
    </View>
  );
};
const createStyles = (theme) =>
  StyleSheet.create({
    headerContainer: {
      marginTop: Platform.OS === 'web' ? 10 : Constants.statusBarHeight,
      paddingHorizontal: 15,
      paddingVertical: 10,
    },
    subTitleText: {
      color: theme.colors.placeHolderText,
      fontWeight: 400,
      fontSize: 11,
    },
    headerInline: {
      justifyContent: 'space-between',
      flexDirection: 'row',
      alignItems: 'center',
    },
    titleText: {
      color: theme.colors.secondaryText,
      fontSize: 24,
      fontWeight: 600,
      width: '100%',
    },
    buttonText: {
      color: theme.colors.blueColor,
      fontWeight: 400,
      fontSize: 13,
    },
  });
export default DetailedHeader;
